module.exports = __webpack_public_path__ + "img/taylorBellCastingHall201027-290.ba7f661e.jpg";